export const AppConstants = {
    CAROUSELTITLE:`Build, Customize, and Deploy applications effortlessly with our AI Agentic platform.`
}